import React, { useState, useEffect } from 'react';
import './ContractScreen.css';
import { api } from '../../services/api';

export default function ContractScreen({ user }) {
  const contracts = user?.contracts || [];
  const [selectedContract, setSelectedContract] = useState(null);
  const [fields, setFields] = useState({
    paymentForContract: '',
    paymentByContractor: '',
    receiptForPayment: '',
    paymentByTenants: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // בחר contract ראשון אם יש
  useEffect(() => {
    if (contracts.length > 0 && !selectedContract) {
      setSelectedContract(contracts[0].DocNum || contracts[0].id);
    }
  }, [contracts, selectedContract]);

  // טען נתונים כשמשנים contract
  useEffect(() => {
    if (!selectedContract || !user) return;

    const fetchContractData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const response = await api.getContractData(
          user.userCode,
          user.type,
          selectedContract
        );
        
        // עדכן את השדות לפי הנתונים מהשרת
        // השרת מחזיר: totPaid, totCntrctPaid, sumReciept, totTnntsPaid
        if (response) {
          // פונקציה עזר להמיר ערך ל-string בטוח עם פורמט מספרי
          const safeValue = (val) => {
            if (val === null || val === undefined) return '';
            if (typeof val === 'object') return '';
            
            // אם זה מספר - הצג עם פורמט מספרי
            if (typeof val === 'number') {
              return val.toLocaleString('he-IL');
            }
            
            return String(val);
          };
          
          setFields({
            // totPaid → סה"כ תשלום לחוזה
            paymentForContract: safeValue(response.totPaid),
            // totCntrctPaid → סה"כ שולם ע"י הקבלן
            paymentByContractor: safeValue(response.totCntrctPaid),
            // sumReciept → סה"כ ניתנה קבלה לתשלום
            receiptForPayment: safeValue(response.sumReciept),
            // totTnntsPaid → סה"כ שולם על ידי הדיירים
            paymentByTenants: safeValue(response.totTnntsPaid),
          });
        }
      } catch (err) {
        console.error('Error fetching contract data:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchContractData();
  }, [selectedContract, user]);

  const handleChange = (e) => {
    setFields({ ...fields, [e.target.name]: e.target.value });
  };

  const handleContractChange = (e) => {
    setSelectedContract(e.target.value);
  };

  if (loading && !selectedContract) {
    return (
      <div style={{ padding: 8, textAlign: 'center' }}>
        <div>טוען...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: 16, textAlign: 'center', color: 'red' }}>
        שגיאה בטעינת נתוני החוזה: {error}
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 420, margin: '8px auto', direction: 'rtl', textAlign: 'right' }}>
      {/* כותרת ותפריט נפתח */}
      <div className="form-container">
        {/* <div className="form-title">חוזה</div> */}
        <select
          value={selectedContract || ''}
          onChange={handleContractChange}
          className="form-select"
        >
          {contracts.map(c => (
            <option key={c.DocNum || c.id} value={c.DocNum || c.id}>
              {c.U_Project || c.name}
            </option>
          ))}
        </select>
        <div className="form-fields">
          <div className="form-row-cnt">
            <input
              className="form-input"
              type="text"
              name="paymentForContract"
              value={fields.paymentForContract}
              onChange={handleChange}
              placeholder="100.00"
            />
            <span className="form-label">סה"כ תשלום לחוזה:</span>
          </div>
          <div className="form-row-cnt">
            <input
              className="form-input"
              type="text"
              name="paymentByContractor"
              value={fields.paymentByContractor}
              onChange={handleChange}
              placeholder="100.00"
            />
            <span className="form-label">סה"כ שולם ע"י הקבלן:</span>
          </div>
          <div className="form-row-cnt">
            <input
              className="form-input"
              type="text"
              name="receiptForPayment"
              value={fields.receiptForPayment}
              onChange={handleChange}
              placeholder="100.00"
            />
            <span className="form-label">סה"כ ניתנת קבלה לתשלום:</span>
          </div>
          <div className="form-row-cnt">
            <input
              className="form-input"
              type="text"
              name="paymentByTenants"
              value={fields.paymentByTenants}
              onChange={handleChange}
              placeholder="100.00"
            />
            <span className="form-label">סה"כ שולם על ידי הדיירים:</span>
          </div>
        </div>
        {/* <button className="form-save-btn">שמור</button> */}
      </div>
    </div>
  );
}
